import { useTranslation } from "react-i18next"

import { SearchBox } from "@/components/search/search-box"
import { Checkbox } from "@/components/ui/checkbox"

import { useCampaignSearchOptions } from "./search-options"

type Props = {
  searchState: ReturnType<typeof useCampaignSearchOptions>
}

export function CampaignSearchBar({ searchState }: Props) {
  const { t } = useTranslation()
  const { onChange, searchOptions } = searchState

  return (
    <div className="flex gap-4">
      <SearchBox
        defaultValue={searchOptions.search_query || ""}
        onChange={onChange("search_query")}
      />
      <div className="flex items-center space-x-2">
        <Checkbox
          id="inactive_include"
          checked={searchState.searchOptions.inactive_include}
          onCheckedChange={onChange("inactive_include")}
        />
        <label htmlFor="inactive_include" className="text-sm">
          {t("campaigns.search.inactiveInclude")}
        </label>
      </div>
    </div>
  )
}
